export default "__VITE_ASSET__b17f7522__"